<template>
  <div class="animated fadeIn">
    <!-- Add new  -->
    <b-row>
      <b-col lg="12" style="margin-bottom:15px">
        <b-row>
          <b-col lg="4">
            <button
              class="btn btn-primary btn-lg btn-block"
              @click="modal = true"
            >
              <b>Add New</b>
            </button>
          </b-col>
          <b-col lg="4">
            <button
              @click="
                (showArchived = false), (onlyMine = onlyMine === 0 ? 1 : 0);
                fetchData(true);
              "
              class="btn btn-secondary btn-lg btn-block"
            >
              <b>{{ onlyMine === 1 ? "See All" : "Show only mine" }}</b>
            </button>
          </b-col>
          <b-col lg="4">
            <button
              @click="(showArchived = !showArchived), fetchData(true)"
              class="btn btn-secondary btn-lg btn-block"
            >
              <b>{{ showArchived ? "Show Active" : "Show Archived" }}</b>
            </button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-modal
      id="addNewTask"
      title="Add New Task"
      class="modal-primary"
      size="lg"
      centered
      v-model="modal"
      @ok="addNew"
    >
      <b-row class="text-center" v-if="loadingTodo">
        <b-spinner
          style="height:55px; width:55px; display:block; margin:auto; margin-top:50px"
          type="grow"
          label="Loading..."
        ></b-spinner>
      </b-row>

      <div v-else>
        <div
          v-if="selectedCategory === '0'"
          class="mb-3"
          style="color: #f5c14c; font-size: 16px; font-weight: bold; text-transform: uppercase"
        >
          You don't have to assign users for the IT related Tasks!
        </div>
        <b-row>
          <b-col lg="8">
            <b-form-textarea
              id="textarea"
              v-model="desc"
              rows="16"
              max-rows="16"
              placeholder="Description"
            />
          </b-col>
          <b-col lg="4">
            <!-- Category -->
            <div>
              <label for="category">Category</label>
              <b-form-select
                id="category"
                v-model="selectedCategory"
                :options="categories"
                style="background-color: #515b65; color: white;border-color:#292929"
                value-field="value"
                text-field="label"
              />
            </div>

            <!-- Priority -->
            <div class="mt-3">
              <label for="priority">Priority</label>
              <b-form-select
                id="priority"
                v-model="selectedPriority"
                :options="priorities"
                style="background-color: #515b65; color: white;border-color:#292929"
                value-field="value"
                text-field="label"
              />
            </div>

            <!-- Users -->
            <div class="mt-3">
              <label for="users">Users</label>
              <button
                class="btn btn-primary btn-block mb-1"
                @click="assignAll()"
              >
                Assign All
              </button>
              <b-form-select
                id="users"
                v-model="selectedOne"
                :options="users"
                style="background-color: #515b65; color: white;border-color:#292929"
                value-field="badge"
                text-field="name"
                @change="updateUsers('add')"
              ></b-form-select>
              <span
                v-for="sel in selectedUsers"
                v-bind:key="sel"
                style="font-size:1em; margin: 5px; display: inline-block"
              >
                {{ users.find(el => el.badge === sel).name }}
                <a @click="updateUsers('remove', sel)" class="text-danger h6"
                  >Remove</a
                >
              </span>
            </div>

            <div class="mt-3">
              <label for="file">Attachment</label>
              <b-form-file
                id="file"
                v-model="attachment"
                :state="Boolean(attachment)"
                style="background: #515b65"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
              />
            </div>
          </b-col>
        </b-row>
      </div>
      <!-- If IT category show this note -->
    </b-modal>

    <!-- TODO LIST / DONE AND UNDONE  -->
    <b-row>
      <!-- TO-DO -->
      <b-col lg="4">
        <b-card>
          <h4>
            To-do
            <span style="font-size: 15px">({{ undone.length }})</span>
          </h4>
          <b-row class="text-center" v-if="loadingTodo">
            <b-spinner
              style="height:55px; width:55px; display:block; margin:auto; margin-top:50px"
              type="grow"
              label="Loading..."
            ></b-spinner>
          </b-row>
          <draggable
            :list="undone"
            :sort="false"
            group="people"
            draggable=".task"
            @change="log"
            v-else
          >
            <b-row class="task" v-for="task in undone" :key="task.task_id">
              <b-col lg="12">
                <div class="row justify-content-between ml-1 mr-1">
                  <p class="card-title" @click="openDetails(task)">
                    Task - {{ task.task_id }}
                  </p>

                  <div :id="`priorityPopover${task.task_id}-sync`">
                    <b-btn
                      class="priority-btn"
                      variant="outline"
                      @click="selectedTask = task.task_id"
                    >
                      <i
                        class="icon-bulb"
                        style="color: #20a8d8; margin-top: -4px;"
                      />
                      Priority
                      <b-badge
                        :variant="priorityColors(parseInt(task.priority))"
                        class="priority-info"
                        style="font-size: 12px"
                      >
                        {{ task.priority }}
                      </b-badge>
                    </b-btn>

                    <b-popover
                      :show.sync="task.task_id === selectedTask"
                      hide
                      :target="`priorityPopover${task.task_id}-sync`"
                      :title="`Select priority for task ${task.task_id}`"
                      custom-class="priority-popover"
                    >
                      <b-row style="width: 200px;" class="ml-1">
                        <b-col md="4" v-for="priority in 10" :key="priority">
                          <b-badge
                            :variant="priorityColors(priority)"
                            class="priority"
                            style="font-size: 12px"
                            :style="priority === 10 && 'width: 165px'"
                            @click="updateTask(task, priority, 'loadingTodo')"
                          >
                            {{ priority }}
                          </b-badge>
                        </b-col>
                      </b-row>

                      <hr style="border-top: 1px solid #444b54" />
                      <b-button
                        size="sm"
                        class="mb-2 float-right"
                        @click="selectedTask = null"
                        >Close</b-button
                      >
                    </b-popover>
                  </div>
                </div>
                <hr style="border-top: 1px solid #444b54" />

                <span class="task-title" @click="openDetails(task)">
                  <!--                            {{parseText(task.desc.slice(0, 510)) + '... '}}-->
                  {{ parseText(task.desc) }}
                </span>
              </b-col>
              <b-col lg="12">
                <hr style="border-top: 1px solid #444b54" />
                <span style="font-size: 12px"
                  >Created: {{ task.created_at }}</span
                >

                <b-img
                  v-b-tooltip.hover
                  :title="task.user"
                  :id="task.id"
                  style="position:absolute; bottom: -20px; right: -28px; border:5px solid #2f353a"
                  v-bind="image"
                  :alt="task.name"
                  :src="task.image"
                  rounded="circle"
                />
              </b-col>
            </b-row>
          </draggable>
        </b-card>
      </b-col>

      <!-- In Progress -->
      <b-col lg="4">
        <b-card>
          <h4>
            In progress
            <span style="font-size: 15px">({{ inprogress.length }})</span>
          </h4>
          <b-row class="text-center" v-if="loadingInProgress">
            <b-spinner class="spinner" type="grow" label="Loading..." />
          </b-row>
          <draggable
            :list="inprogress"
            :sort="false"
            group="people"
            draggable=".task"
            @change="log"
            v-else
          >
            <b-row class="task" v-for="task in inprogress" v-bind:key="task.id">
              <b-col lg="12">
                <div class="row justify-content-between ml-1 mr-1">
                  <p class="card-title" @click="openDetails(task)">
                    Task - {{ task.task_id }}
                  </p>

                  <div :id="`priorityPopover${task.task_id}-sync`">
                    <b-btn
                      class="priority-btn"
                      variant="outline"
                      @click="selectedTask = task.task_id"
                    >
                      <i
                        class="icon-bulb"
                        style="color: #20a8d8; margin-top: -4px;"
                      />
                      Priority
                      <b-badge
                        :variant="priorityColors(parseInt(task.priority))"
                        class="priority-info"
                        style="font-size: 12px"
                      >
                        {{ task.priority }}
                      </b-badge>
                    </b-btn>

                    <b-popover
                      :show.sync="task.task_id === selectedTask"
                      hide
                      :target="`priorityPopover${task.task_id}-sync`"
                      :title="`Select priority for task ${task.task_id}`"
                      custom-class="priority-popover"
                    >
                      <b-row style="width: 200px;" class="ml-1">
                        <b-col md="4" v-for="priority in 10" :key="priority">
                          <b-badge
                            :variant="priorityColors(priority)"
                            class="priority"
                            style="font-size: 12px"
                            :style="priority === 10 && 'width: 165px'"
                            @click="
                              updateTask(task, priority, 'loadingInProgress')
                            "
                          >
                            {{ priority }}
                          </b-badge>
                        </b-col>
                      </b-row>

                      <hr style="border-top: 1px solid #444b54" />
                      <b-button
                        size="sm"
                        class="mb-2 float-right"
                        @click="selectedTask = null"
                        >Close</b-button
                      >
                    </b-popover>
                  </div>
                </div>
                <hr style="border-top: 1px solid #444b54" />

                <span class="task-title" @click="openDetails(task)">
                  <!--                            {{parseText(task.desc.slice(0, 510)) + '... '}}-->
                  {{ parseText(task.desc) }}
                </span>
              </b-col>
              <b-col lg="12">
                <hr style="border-top: 1px solid #444b54" />
                <span style="font-size: 12px"
                  >Created: {{ task.created_at }}</span
                >

                <b-img
                  v-b-tooltip.hover
                  :title="task.user"
                  :id="task.id"
                  style="position:absolute; bottom: -20px; right: -28px; border:5px solid #2f353a"
                  v-bind="image"
                  :alt="task.name"
                  :src="task.image"
                  rounded="circle"
                />
              </b-col>
            </b-row>
          </draggable>
        </b-card>
      </b-col>

      <!-- Done -->
      <b-col lg="4">
        <b-card>
          <h4>
            Done
            <span style="font-size: 15px">({{ done.length }})</span>
          </h4>
          <b-row class="text-center" v-if="loadingDone">
            <b-spinner
              style="height:55px; width:55px; display:block; margin:auto; margin-top:50px"
              type="grow"
              label="Loading..."
            ></b-spinner>
          </b-row>
          <draggable
            :list="done"
            :sort="false"
            group="people"
            draggable=".task"
            @change="log"
            v-else
          >
            <b-row class="task" v-for="task in done" v-bind:key="task.id">
              <b-col lg="12">
                <div class="row justify-content-between ml-1 mr-1">
                  <p class="card-title" @click="openDetails(task)">
                    Task - {{ task.task_id }}
                  </p>

                  <div :id="`priorityPopover${task.task_id}-sync`">
                    <b-btn
                      class="priority-btn"
                      variant="outline"
                      @click="selectedTask = task.task_id"
                    >
                      <i
                        class="icon-bulb"
                        style="color: #20a8d8; margin-top: -4px;"
                      />
                      Priority
                      <b-badge
                        :variant="priorityColors(parseInt(task.priority))"
                        class="priority-info"
                        style="font-size: 12px"
                      >
                        {{ task.priority }}
                      </b-badge>
                    </b-btn>

                    <b-popover
                      :show.sync="task.task_id === selectedTask"
                      hide
                      :target="`priorityPopover${task.task_id}-sync`"
                      :title="`Select priority for task ${task.task_id}`"
                      custom-class="priority-popover"
                    >
                      <b-row style="width: 200px;" class="ml-1">
                        <b-col md="4" v-for="priority in 10" :key="priority">
                          <b-badge
                            :variant="priorityColors(priority)"
                            class="priority"
                            style="font-size: 12px"
                            :style="priority === 10 && 'width: 165px'"
                            @click="updateTask(task, priority, 'loadingDone')"
                          >
                            {{ priority }}
                          </b-badge>
                        </b-col>
                      </b-row>

                      <hr style="border-top: 1px solid #444b54" />
                      <b-button
                        size="sm"
                        class="mb-2 float-right"
                        @click="selectedTask = null"
                        >Close</b-button
                      >
                    </b-popover>
                  </div>
                </div>
                <hr style="border-top: 1px solid #444b54" />

                <span class="task-title" @click="openDetails(task)">
                  <!--                            {{parseText(task.desc.slice(0, 510)) + '... '}}-->
                  {{ parseText(task.desc) }}
                </span>
              </b-col>
              <b-col lg="12">
                <hr style="border-top: 1px solid #444b54" />
                <span style="font-size: 12px"
                  >Created: {{ task.created_at }}</span
                >

                <b-img
                  v-b-tooltip.hover
                  :title="task.user"
                  :id="task.id"
                  style="position:absolute; bottom: -20px; right: -28px; border:5px solid #2f353a"
                  v-bind="image"
                  :alt="task.name"
                  :src="task.image"
                  rounded="circle"
                />
              </b-col>
            </b-row>
          </draggable>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { format } from "date-fns";
import draggable from "vuedraggable";
import router from "../../router";
import { allowedPath } from "../../shared/utils";
import { el } from "date-fns/locale";

export default {
  name: "TodoList",
  components: { draggable },
  computed: {
    showIt() {
      return this.$route.query.showIt;
    }
  },
  data: function() {
    return {
      selectedUserOnTask: "",
      loadingTodo: true,
      loadingInProgress: true,
      loadingDone: true,
      selectedTask: null,
      done: [],
      undone: [],
      modal: false,
      onlyMine: 1,
      inprogress: [],
      desc: "",
      selectedOne: null,
      selectedUsers: [],
      users: [
        { label: "Goran", value: "1125" },
        { label: "Vladimir", value: "1211" }
      ],
      image: { blank: false, width: 55, height: 55, class: "" },
      showArchived: false,
      selectedCategory: "1",
      categories: [
        {
          label: "Non IT",
          value: "1"
        },
        {
          label: "IT",
          value: "0"
        }
      ],
      selectedPriority: 1,
      priorities: [
        {
          label: "1",
          value: "1"
        },
        {
          label: "2",
          value: "2"
        },
        {
          label: "3",
          value: "3"
        },
        {
          label: "4",
          value: "4"
        },
        {
          label: "5",
          value: "5"
        },
        {
          label: "6",
          value: "6"
        },
        {
          label: "7",
          value: "7"
        },
        {
          label: "8",
          value: "8"
        },
        {
          label: "9",
          value: "9"
        },
        {
          label: "10",
          value: "10"
        }
      ],
      attachment: null,
      newTaskId: null
    };
  },
  watch: {
    "$route.query"() {
      this.fetchData(true);
    }
  },
  methods: {
    assignAll() {
      this.selectedUsers = [];
      this.users.forEach(el => {
        this.selectedUsers.push(el.badge);
      });
    },
    parseText(data) {
      return data.replace(/&quot;/g, '"').replace(/&amp;/g, "&");
    },
    updateUsers(type, user) {
      if (type == "add") {
        if (!this.selectedUsers.find(el => el == this.selectedOne)) {
          this.selectedUsers.push(this.selectedOne);
        }
      } else {
        console.log(user);
        const index = this.selectedUsers.indexOf(user);
        if (index > -1) {
          this.selectedUsers.splice(index, 1);
        }
      }
      this.selectedOne = null;
      console.log(type);
    },
    addNew(event) {
      event.preventDefault();
      this.loadingTodo = true;
      const formData = new FormData();
      formData.append("desc", this.desc);
      formData.append("users", this.selectedUsers.toString());
      formData.append("category", this.selectedCategory);
      formData.append("priority", this.selectedPriority);

      this.$http.post("api/fns/todoList/addItem.php", formData).then(
        res => {
          console.log("res", res);
          // Check if there is an attachment and send it to the API
          this.newTaskId = res.data.task_id;

          if (this.attachment) {
            console.log("we have an attachment");
            this.addFile().then(() => {
              this.modal = false;
              this.clearModalData();
              this.fetchData();
            });
          } else {
            this.modal = false;
            this.clearModalData();
            this.fetchData();
          }
        },
        err => {
          this.loadingTodo = false;
          console.log(err);
          this.modal = false;
        }
      );
    },

    clearModalData() {
      this.attachment = null;
      this.desc = "";
      this.selectedCategory = "1";
      this.selectedPriority = 1;
      this.selectedUsers = [];
      this.newTaskId = null;
      this.modal = false;
    },

    addFile() {
      this.loadingFile = true;
      const formData = new FormData();
      formData.append("file", this.attachment);
      formData.append("task", this.newTaskId);

      return this.$http.post("api/fns/todoList/addFile.php", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
    },

    fetchData(showSpinners) {
      if (showSpinners) {
        this.loadingTodo = true;
        this.loadingInProgress = true;
        this.loadingDone = true;
      }

      const params = {
        onlyMine: this.onlyMine,
        category: this.showIt === "1" ? 0 : 1
        // category: 0
      };
      let url = "api/fns/todoList/listItems.php";
      if (this.showArchived) {
        url = "api/fns/todoList/listArchivedItems.php";
      }
      this.$http.get(url, { params }).then(
        res => {
          console.log("res", res);
          this.undone = [];
          this.done = [];
          this.inprogress = [];
          res.data.forEach(element => {
            if (element.status == "0") {
              this.undone.push(element);
            } else if (element.status === "1") {
              this.inprogress.push(element);
            } else {
              this.done.push(element);
            }
          });
          this.loadingTodo = false;
          this.loadingInProgress = false;
          this.loadingDone = false;
          this.selectedTask = null;
        },
        err => {
          this.loadingTodo = false;
          this.loadingInProgress = false;
          this.loadingDone = false;
          console.log(err);
        }
      );

      this.$http.get("api/fns/todoList/portalUsers.php").then(
        res => {
          this.users = res.data;
        },
        err => {
          this.loadingTodo = false;
          this.loadingInProgress = false;
          this.loadingDone = false;
          console.log(err);
        }
      );
    },

    openDetails(task) {
      this.$router.push("/base/TodoList-Details/?task=" + task.task_id);
    },

    updateTask(task, priority, loading) {
      this[loading] = true;
      console.log(task);
      const formData = new FormData();
      formData.append("id", task.task_id);
      formData.append("status", task.status);
      formData.append("desc", task.desc);
      formData.append("category", task.category);
      formData.append("priority", priority);
      formData.append("oldStatus", task.status);

      this.$http.post("api/fns/todoList/updateItem.php", formData).then(
        () => {
          this.fetchData();
        },
        err => {
          console.log(err);
        }
      );
    },

    log: function(evt) {
      if ("added" in evt) {
        let status = 0;
        if (this.undone.find(el => el === evt.added.element)) {
          this.oldStatus = evt.added.element.status;
          evt.added.element.status = status;
        } else if (this.inprogress.find(el => el === evt.added.element)) {
          this.oldStatus = evt.added.element.status;
          status = 1;
          evt.added.element.status = status
        } else {
          this.oldStatus = evt.added.element.status;
          status = 2;
          evt.added.element.status = status
        }

        const formData = new FormData();
        formData.append("id", evt.added.element.task_id);
        formData.append("status", status);
        formData.append("desc", evt.added.element.desc);
        formData.append("category", evt.added.element.category);
        formData.append("priority", evt.added.element.priority);
        formData.append("user_on_task", evt.added.element.user_on_task);
        formData.append("oldStatus",  this.oldStatus);

        // if status is in progress update start date
        if (status === 1) {
          const now = format(new Date(), "yyyy-MM-dd H:mm:ss");
          formData.append("start_date", now);
        }

        // if status is done update end date
        if (status === 2 || status === 3) {
          const now = format(new Date(), "yyyy-MM-dd H:mm:ss");
          formData.append("end_date", now);
        }

        this.$http.post("api/fns/todoList/updateItem.php", formData);
      }
    },
    priorityColors(value) {
      if (value < 4) {
        return "light";
      } else if (value < 7) {
        return "info";
      } else if (value < 10) {
        return "warning";
      } else if (value === 10) {
        return "danger";
      }
    }
  },

  mounted() {
    allowedPath(
      router.currentRoute.path,
      localStorage.getItem("user_tabs"),
      localStorage.getItem("redirect_path")
    );
    if (
      localStorage.getItem("fns_user") == "1030" ||
      localStorage.getItem("fns_user") == "1034" ||
      localStorage.getItem("fns_user") == "1050" ||
      localStorage.getItem("fns_user") == "1227"
    ) {
      this.onlyMine = 0;
    }
    this.fetchData(true);
  }
};
</script>

<style>
.priority-popover {
  background-color: #3a4149;
}

.priority-popover .popover-header {
  background-color: #3a4149;
  font-size: 16px;
  font-weight: bold;
  padding: 20px;
}

.priority-btn {
  color: white;
  border: none !important;
  margin-top: 5px;
  padding: 0;
}

.task {
  border: 3px solid #2f353a;
  background: #2f353a;
  border-radius: 5px;
  padding: 20px 10px 20px 1px;
  margin: 20px 2px;
  cursor: pointer;
}

.task-title {
  font-size: 16px;
}

.priority {
  cursor: pointer;
  padding: 12px;
  margin: 7px;
}

.priority-info {
  cursor: pointer;
  margin-left: 3px;
}

.card-title {
  font-size: 18px;
  font-weight: bold;
}

/*.popover {*/
/*  background: #3a4149 !important;*/
/*  color: white*/
/*}*/
/*.popover-header {*/
/*  background: #3a4149 !important;*/
/*}*/
.bs-popover-right > .arrow::before,
.bs-popover-auto[x-placement^="right"] > .arrow::before {
  border-right-color: #3a4149;
}

.bs-popover-right > .arrow::after,
.bs-popover-auto[x-placement^="right"] > .arrow::after {
  border-right-color: #3a4149;
}

.spinner {
  height: 55px;
  width: 55px;
  display: block;
  margin: auto;
  margin-top: 50px;
}

.custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #2b2b2b !important;
  background: #515b65 !important;
  color: #ffffff38 !important;
}

.custom-file-input ~ .custom-file-label {
  border-color: #2b2b2b !important;
  background: #515b65 !important;
  color: white !important;
}

.custom-file-input ~ .custom-file-label[data-browse]::after {
  display: none !important;
}
</style>
